export const GET_DOCTORS_FOR_ORG = "GET_DOCTORS_FOR_ORG";
export const GET_DOCTORS_FOR_HC_ORG = "GET_DOCTORS_FOR_HC_ORG";
export const GET_DOCTORS_FOR_DEPT = "GET_DOCTORS_FOR_DEPT";
export const GET_DOCTORS = "GET_DOCTORS";
export const ADD_DOCTOR = "ADD_DOCTOR";
export const ADD_DOCTOR_FROM_EXISTING_USER = "ADD_DOCTOR_FROM_EXISTING_USER";
export const REMOVE_DOCTOR_FROM_DEPT = "REMOVE_DOCTOR_FROM_DEPT";
export const TOGGLE_DOCTOR_HEAD = "TOGGLE_DOCTOR_HEAD";
export const TOGGLE_DOCTOR_PRIVILEGES = "TOGGLE_DOCTOR_PRIVILEGES";
export const GET_USER_BY_EMAIL = "GET_USER_BY_EMAIL";
export const GET_ORG_DOCTORS = "GET_ORG_DOCTORS";

/**
 * action creator function to add doctor
 * @param doctor: doctor from api response data
 * @returns {{doctor, type: string}}
 */
export const addDoctor = (doctor) => {
  return {
    type: ADD_DOCTOR,
    doctor: doctor,
  };
};

/**
 * action creator function to add doctor from existing user
 * @param doctor: doctor from api response data
 * @returns {{doctor, type: string}}
 */
export const addDoctorFromExistingUser = (doctor) => {
  return {
    type: ADD_DOCTOR_FROM_EXISTING_USER,
    doctor: doctor,
  };
};

/**
 * action creator function to get doctors for a organization
 * @param doctors: doctors from api response data
 * @returns {{doctors, type: string}}
 */
export const getDoctorsForOrg = (doctors) => {
  return {
    type: GET_DOCTORS_FOR_ORG,
    doctors: doctors,
  };
};

/**
 * action creator function to get doctors for a healthcare organization
 * @param doctors: doctors from api response data
 * @returns {{doctors, type: string}}
 */
export const getDoctorsForHCOrg = (doctors) => {
  return {
    type: GET_DOCTORS_FOR_HC_ORG,
    doctors: doctors,
  };
};

/**
 * action creator function to get doctors for a department
 * @param doctors: doctors from api response data
 * @returns {{doctors, type: string}}
 */
export const getDoctorsForDept = (doctors) => {
  return {
    type: GET_DOCTORS_FOR_DEPT,
    doctors: doctors,
  };
};

/**
 * action creator function to remove doctor from a department
 * @param doctor: doctor to be removed
 * @returns {{doctor, type: string}}
 */
export const removeDoctorFromDept = (doctor) => {
  return {
    type: REMOVE_DOCTOR_FROM_DEPT,
    doctor: doctor,
  };
};

/**
 * action creator function to toggle doctor head
 * @param doctor: doctor
 * @returns {{doctor, type: string}}
 */
export const toggleDoctorHead = (doctor) => {
  return {
    type: TOGGLE_DOCTOR_HEAD,
    doctor: doctor,
  };
};

/**
 * action creator function to toggle doctor clinical privileges
 * @param doctor
 * @returns {{doctor, type: string}}
 */
export const toggleDoctorPrivileges = (privilege) => {
  return {
    type: TOGGLE_DOCTOR_PRIVILEGES,
    privilege: privilege,
  };
};

/**
 * action creator function to get user by email
 * @param user
 * @returns {{type: string, user}}
 */
export const getUserByEmail = (user) => {
  return {
    type: GET_USER_BY_EMAIL,
    user: user,
  };
};

export const getDoctors = (doctors) => {
  return {
    type: GET_DOCTORS,
    doctors: doctors,
  };
};

export const getOrgDoctors = (doctors) => {
  return {
    type: GET_ORG_DOCTORS,
    doctors: doctors,
  };
};
